import React, { useEffect, useRef, useState } from 'react';
import { useStoreModal } from './storeModalContext';

const CtaFinal: React.FC = () => {
  const btnRef = useRef<HTMLButtonElement>(null);
  const [pulse, setPulse] = useState(false);
  const { open: openStore } = useStoreModal();

  useEffect(() => {
    const el = btnRef.current;
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const po = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            setPulse(true);
            po.unobserve(el);
          }
        });
      },
      { threshold: 0.6 }
    );
    po.observe(el);
    return () => po.disconnect();
  }, []);

  return (
    <section id="cta-final">
      <div className="cta-final-pattern" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" preserveAspectRatio="xMidYMid slice">
          <defs>
            <pattern id="khatam2" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
              <g transform="translate(40 40)" fill="none" stroke="currentColor" strokeWidth="0.7">
                <rect x="-22" y="-22" width="44" height="44" />
                <rect x="-22" y="-22" width="44" height="44" transform="rotate(45)" />
                <circle cx="0" cy="0" r="3" fill="currentColor" stroke="none" opacity="0.6" />
              </g>
            </pattern>
          </defs>
          <rect width="800" height="800" fill="url(#khatam2)" />
        </svg>
      </div>
      <div className="cta-final-inner">
        <h2 className="cta-final-h2 reveal">
          Live Islam, not just <em>learn it.</em>
        </h2>
        <p className="cta-final-sub reveal reveal-delay-1">
          Join 100,000+ Muslims building a daily Islamic practice - one lesson, one prayer, one day at a time.
        </p>
        <button
          type="button"
          className={`cta-final-cta reveal reveal-delay-2${pulse ? ' pulse' : ''}`}
          ref={btnRef}
          onClick={() => openStore()}
        >
          Start now
        </button>
        <p className="cta-final-trust reveal reveal-delay-3">
          7 days free <span>·</span> Cancel anytime
        </p>
      </div>
    </section>
  );
};

export default CtaFinal;
